import React from "react";
import Modal from "react-modal";
import ModalContent from "./ModalContent";
import styles from "./ModalWrapper.scss";

const ModalWrapper = props => {
  return (
    <Modal
      appElement={props.appElement}
      isOpen={props.isOpen}
      style={{
        overlay: {
          backgroundColor: props.backdropColour
        }
      }}
      contentLabel={props.modalNewsItem.SubjectTitle}
      className={styles.content}
      overlayClassName={styles.overlay}
      onRequestClose={props.onRequestClose}
      closeTimeoutMS={500}
    >
      <ModalContent
        handleCloseModal={props.onRequestClose}
        modalNewsItem={props.modalNewsItem}
        settings={props.settings}
      />
    </Modal>
  );
};

export default ModalWrapper;
